function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "f387838d-f757-4c50-b32f-f100b9eee82d",
  "data-name": "Fill-1",
  d: "M20,8.51a.87.87,0,0,0-.76.87V10l-.13-.1A6.75,6.75,0,0,0,15,8.5a6.5,6.5,0,1,0,6.5,6.74.88.88,0,0,0-1.75-.07A4.75,4.75,0,1,1,15,10.25h.24a5,5,0,0,1,2.89,1.15l.1.09H17.06a.88.88,0,0,0,0,1.75h3.2l.07,0,.13-.06h0l.1-.07.06-.05.1-.11.09-.13.05-.13,0-.07,0-.07V9.38a.87.87,0,0,0-.88-.88Z"
});

var SvgIconReset = function SvgIconReset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-reset.80cf5060.svg";
export { ForwardRef as ReactComponent };